import { Input } from "../../../components/Input/Input";
import { FieldRow } from "../../projects/config/FieldRow";
import { SectionCard } from "../../projects/config/SectionCard";
import type { BotsNewcomerConfig } from "../config/types";
import styles from "./BotsSettings.module.css";

interface Props {
  value: BotsNewcomerConfig;
  onChange: (patch: Partial<BotsNewcomerConfig>) => void;
  dirty: boolean;
}

/**
 * `bots.newcomer_boost` — the first hour after a living player joins a guild.
 *
 * Mockup: bots-page-shell.html §4, "Newcomer boost". Moved verbatim.
 */
export function NewcomerSection({ value, onChange, dirty }: Props) {
  return (
    <SectionCard
      id="newcomer"
      title="Newcomer boost"
      apiName="bots.newcomer_boost"
      dirty={dirty}
    >
      <FieldRow
        name="Newcomer's first hour"
        apiName="bots.newcomer_boost"
        hint="Right after a real player joins: a welcome, faster replies, faster help. Decays to normal afterwards."
      >
        <div className={styles.pair}>
          <span className={styles.unit}>window</span>
          <Input
            className={styles.narrow}
            type="number"
            value={String(value.window_minutes)}
            onChange={(e) =>
              onChange({ window_minutes: Number(e.target.value) })
            }
            aria-label="Newcomer window"
          />
          <span className={styles.unit}>min</span>
          <span className={styles.unit}>speed-up</span>
          <Input
            className={styles.narrow}
            type="number"
            step="0.1"
            value={String(value.speed_up)}
            onChange={(e) => onChange({ speed_up: Number(e.target.value) })}
            aria-label="Newcomer speed-up"
          />
          <span className={styles.unit}>×</span>
          <span className={styles.unit}>welcome</span>
          <Input
            className={styles.narrow}
            type="number"
            value={String(value.welcome_probability)}
            onChange={(e) =>
              onChange({ welcome_probability: Number(e.target.value) })
            }
            aria-label="Welcome probability"
          />
          <span className={styles.unit}>%</span>
        </div>
      </FieldRow>
    </SectionCard>
  );
}
